<template>
    <div v-anchor>
        <div class="paperHeader">
            <Navigation :route="navigationRoute"></Navigation>
            <div class="paperHeaderTop mt-20">
                <div class="paperHeaderTop-title">
                    {{paperInfo.name}}
                </div>
                <div class="paperHeaderTop-c">
                    <div class="flex-btw mt-20">
                        <div>
                            <span class="paperHeaderTop-c-label">考试时间：</span>
                            {{paperInfo.startTime}}—{{paperInfo.endTime}}
                        </div>
                        <div>
                            <span class="paperHeaderTop-c-label">考试时间：</span>
                            {{paperInfo.duration||''}}分钟
                        </div>
                        <div>
                            <span class="paperHeaderTop-c-label">试卷总分：</span>
                            {{paperInfo.totalScore||''}}分
                        </div>
                        <div>
                            <span class="paperHeaderTop-c-label">及格分：</span>
                            {{paperInfo.passedScore||''}}分
                        </div>
                    </div>
                    <!-- <div class="flex mt-20">
                        <div>
                            <span class="paperHeaderTop-c-label">培训班：</span>
                            {{paperInfo.duration||''}}
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
        <div class="paper-con">
            <div class="paper-content">
                <div class="question-sections" v-for="(sec, secIndex) in paper.sections" :key="'s' + secIndex">
                    <div class="paperSecTitle">
                        {{ secIndex + 1 | toChinesNum }}、{{ quesMap[sec.trealType] }}（共{{ sec.tnum
                        }}小题，每题{{ sec.tscore }}分，共{{ sec.tscore * sec.tnum }}分）
                    </div>
                    <div v-for="(question, questionIndex) in sec.questions" :key="'q' + questionIndex"
                        class="page-question" :id="question.type + '_' + questionIndex">
                        <div class="question-item" :id="'IdDiv' + question.id">
                            <!-- <div class="question-title-item">
                                <div class="question-title"
                                    v-html="'【' + quesMap[question.type] + '】' + (questionIndex + 1) + '、' + deleteP(question.content)">
                                </div>
                            </div> -->

                            <div class="question-select mt-10"
                                v-if="question.type == 'SINGLECHOICE' || question.type == 'MULTIPLECHOICE' || question.type == 'JUDGMENT'">
                                <choice :info="question" :no="questionIndex"  :readOnly="readOnly"
                                    :check="checks[question.id]" v-model="answers['Q-'+question.id]"></choice>
                            </div>


                            <!-- 套题开始 -->
                            <div v-else-if="question.type == 'TT'" class=" mt-10">
                                <tt :info="question" :readOnly="readOnly" :lastNext="true" :submit="true"
                                    @input="change">
                                </tt>
                                <!-- <div v-for="(child, childIndex) in question.children" :key="childIndex"
                                    class="page-question">
                                    <div class="question-item">
                                       
                                        <div class="question-select mt-10"
                                            v-if="child.type == 'SINGLECHOICE' || child.type == 'MULTIPLECHOICE' || child.type == 'JUDGMENT'">
                                            <choice :info="child" :no="childIndex" @choose="change" :readOnly="readOnly"
                                                :check="checks[child.id]" v-model="answers[child.id]"></choice>
                                        </div>

                                        <div v-else>
                                            <div class=" mt-10" v-if="child.type == 'BLANKFILL'">
                                                <blank class="mt-10" :info="child" :no="childIndex" :readOnly="readOnly"
                                                    :check="checks[child.id]" v-model="answers[child.id]"></blank>
                                            </div>
                                            <div class="question-textarea mt-10" v-else>
                                                <essay :info="child" :no="childIndex" :readOnly="readOnly"
                                                    :check="checks[child.id]" v-model="answers[child.id]"></essay>
                                            </div>

                                        </div>
                                    </div>
                                </div> -->
                            </div>
                            <!-- 套题结束 -->

                            <div v-else>
                                <div class=" mt-10" v-if="question.type == 'BLANKFILL'">
                                    <blank class="mt-10" :info="question" :no="questionIndex" :readOnly="readOnly"
                                        :check="checks[question.id]" v-model="answers['Q-'+question.id]"></blank>
                                </div>
                                <div class="question-textarea mt-10" v-else>
                                    <essay :info="question" :no="questionIndex" :readOnly="readOnly"
                                        :check="checks[question.id]" v-model="answers['Q-'+question.id]"></essay>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="page-question-cardList">
                    <div class="page-answer-card-title">
                        主观题答题卡
                    </div>
                    <div class="page-answer-card-content">
                        <div class="card-image" v-for="(image,i) in cardList" :key="image.id">
                            <el-image
                                style="width: 100%;height: 100%;"
                                :src="image.url"
                                :preview-src-list="[image.url]">
                            </el-image>
                            <i class="el-icon-circle-close cRed delIcon" @click="handleDelete(image.id,i)"></i>
                        </div>
                    </div>
                </div>

                <div class="question-btn">

                    <input ref="fileRef" class="input" type="file" @change="handleChange" style="display:none"/>
                    <el-button type="warning" size="mini" @click="handleUploadQuesCard">上传答题卡</el-button>
                    <el-button type="warning" size="mini" @click="handleSubmit">提交试卷</el-button>
                    
                </div>
            </div>
            <!-- 答题卡 -->
            <div class="answerBox ml-15">
                <div class="answerBox-date flex-btw">
                    <div class="flex-ctr">
                        <img src="@/assets/images/icon9.png" alt="" width="25" height="25">
                        <div class="btn-item-text ml-10">{{ countDownTime }}</div>
                    </div>
                    <el-button type="warning" size="mini" @click="handleSubmit">提交试卷</el-button>
                </div>
                <cardList :list="paper.sections" @submit="submit(1)" :answers="answers" v-if="paper.sections">
                </cardList>
            </div>
        </div>

    </div>
</template>

<script>
import Navigation from "@/components/Navigation.vue";
import { saveData, start, submit,saveCard,delCard } from "@/api/myTest.js";
import { mapState, mapMutations } from "vuex";
import choice from "@/components/question/choice.vue";
import blank from "@/components/question/blank.vue";
import essay from "@/components/question/essay.vue";
import cardList from "@/components/question/cardList.vue";
import tt from "@/components/question/tt.vue";
import examData from "./exam.json"
import { quesMap } from "@/utils/enum"
export default {
    name: "",
    components: {
        Navigation,
        choice,
        blank,
        essay,
        cardList,
        tt,

    },
    data() {
        return {
            navigationRoute: [
                { name: '我的测试' },
                { name: '我的考试' },
            ],
            readOnly: false,
            quesMap,
            title: '',
            shortestDeliverLeftTime: 0,
            answers: {
            },
            paper: {

            },
            cardList: [],
            paperId: '',
            url: '',
            timer: null,
            submitTimer: null,
            timerCountDown: null,
            paperInfo: {},
            imgList: [],
            countDownTime: 0,
            checks: {}
        };
    },
    created() {
        this.paperId = this.$route.query.paperId
        this.start()
    },
    computed: {
    },
    beforeDestroy(){
        this.clearTime()
    },
    methods: {
        clearTime(){
            if(this.timerCountDown){
                clearInterval(this.timerCountDown)
            }
            if(this.timer){
                clearInterval(this.timer)
            }
            if(this.submitTimer){
                clearInterval(this.submitTimer)
            }
        },
        start() {
            const that = this
            start({ paperId: this.paperId }).then(res => {

            this.cardList = res.cardList
            this.answers = res.studentAnswer
            // 
            var paperData = res.paperContent
            paperData.sections.map(pv => {
                pv.questions.map(v => {
                    var reg = new RegExp('\\[BlankArea\\d]', 'g');
                    v.content = v.content.replace(reg, '____');
                    // 
                    // if (pv.trealType == 'BLANKFILL') {
                    //     if (that.answers['Q-' + v.id]) {
                    //         that.answers['Q-' + v.id] = that.answers['Q-' + v.id].split(',')
                    //     } else {
                    //         that.answers['Q-' + v.id] = []
                    //         v.blanks.map(b => {
                    //             that.answers['Q-' + v.id].push('')
                    //         })
                    //     }
                    // }
                })
            })
            this.paper = paperData

            this.shortestDeliverLeftTime = res.paperInfo.shortestDeliverLeftTime

            this.title = this.paper.name

            this.paperInfo = res.paperInfo
            let s = res.paperInfo.shortestSurplusTime
            if(s>0){
                this.countDownTime = this.timeFormat2(s)
					}
            this.timerCountDown = setInterval(() => {
                if (s <= 0) {
                    this.countDownTime = "00:00:00"
                    clearInterval(this.timerCountDown)
                    this.handleSubmit()
                } else {
                    s--
                    this.countDownTime = this.timeFormat2(s)
                }
            }, 1000)

            // 开启提交试卷的倒计时
            this.timer = setInterval(() => {
                if (this.shortestDeliverLeftTime == 0) {
                    clearInterval(this.timer)
                } else {
                    this.shortestDeliverLeftTime--
                }
            }, 1000)

            // 定时保存答卷
            const sec = this.paperInfo.intervalTime * 1000
            this.submitTimer = setInterval(() => {
                // 不校验没到提交时间的问题
                this.savePaper()
            }, sec)
            })

        },
        timeFormat(sec){
            const s = parseInt(sec)
            if(s < 60){
                return `${s}秒`
            }else if(s > 60 && s < 3600){
                const min = parseInt(s/60) // 分钟
                const second = s - min*60 // 秒
                
                return `${min}分${second}秒`
            } else {
                const h = parseInt(s/3600) // 小时
                const min = parseInt((s - h*3600)/60) //分钟
                const second = s - h*3600 - min*60 // 秒
                return `${h}小时${min}分${second}秒`
            }
        },
        timeFormat2(sec) {
            const s = parseInt(sec)
            if (s < 60) {
                let sStr = s
                if (s < 10) {
                    sStr = '0' + s
                }
                return `00:00:${sStr}`
            } else if (s > 60 && s < 3600) {
                const min = parseInt(s / 60) // 分钟
                const second = s - min * 60 // 秒
                let minStr = min
                if (min < 10) {
                    minStr = '0' + min
                }

                let secondStr = second
                if (second < 10) {
                    secondStr = '0' + second
                }

                return `00:${minStr}:${secondStr}`
            } else {
                const h = parseInt(s / 3600) // 小时
                const min = parseInt((s - h * 3600) / 60) //分钟
                const second = s - h * 3600 - min * 60 // 秒
                let hStr = h
                if (h < 10) {
                    hStr = '0' + h
                }

                let minStr = min
                if (min < 10) {
                    minStr = '0' + min
                }

                let secondStr = second
                if (second < 10) {
                    secondStr = '0' + second
                }
                return `${hStr}:${minStr}:${secondStr}`
            }
        },
        // 定时保存试卷
        savePaper() {
            // console.log('提交----')
            var answers = JSON.parse(JSON.stringify(this.answers))
            for (let key in answers) {
                if (answers[key] instanceof Array) {
                    answers[key] = answers[key].join(',')
                }
            }
            saveData({
                paperId: this.paperId,
                ...answers
            }).then((res) => {
                if (res.code == 0) {

                }
            })

        },
        // 提交试卷
        handleSubmit() {
            const _this = this
            if (this.shortestDeliverLeftTime > 0) {
                const tip = this.timeFormat(this.shortestDeliverLeftTime)
                this.$message({
                    showClose: true,
                    message: `${tip}后才能提交试卷`,
                    type: 'error'
                });
                return
            }
            submit({
                paperId: this.paperId,
                ...this.answers
            }).then((res) => {
                _this.clearTime()
                _this.$router.go(-1)
            })
        },
        handleUploadQuesCard(url) {
            this.$refs.fileRef.click()

        },
        handleChange (file, warp) {
        const uploadFile = this.$refs["fileRef"].files[0]
        const fileSize = uploadFile.size / 1024  //kb
        const fileName = uploadFile.name
 
        let fileObj = {
          fileName: fileName,
          fileSize: (fileSize).toFixed(1)
        }
        //转base64传输
        this.compressImage(uploadFile)
      },
      compressImage(file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        const img = new Image();
        img.src = e.target.result;
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          // 定义压缩比例，例如0.6意味着压缩到原始大小的60%
          const compressionRatio = 0.6;
          canvas.width = img.width * compressionRatio;
          canvas.height = img.height * compressionRatio;
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          canvas.toBlob((blob) => {
            // 你可以在这里处理压缩后的blob，例如上传到服务器
            // 或者转换成Base64再次处理
            const reader2 = new FileReader();
            reader2.readAsDataURL(blob);
            reader2.onloadend = () => {
              this.uploadImage(reader2.result); // 可以上传或进一步处理Base64编码的图片
            };
          }, 'image/jpeg', 0.8); // 可以调整压缩质量（0.0 到 1.0）
        };
      };
    },
    uploadImage(base64Image) {
        const _this=this
        saveCard({
            dataId:_this.paperInfo.dataId,
            url:base64Image
           }).then((res) => {
                _this.cardList.push(res)
            })
    },
      transferBase64 (files, obj) {
        // 先判断浏览器是否支持
        if (window.FileReader === 'undefined') {
          alert("您的浏览器不支持图片上传")
          return
        }
        // fileReader读取文件，可以转化为base64
        const reader = new FileReader()
        reader.readAsDataURL(files)  // 转为base64
        reader.onload = () => {
            reader.result
           
          
        }
      },
      handleDelete(id,i){
        console.log(id,i)
        delCard({id}).then((res) => {
                this.cardList.splice(i,1)
            })
      },
        deleteP(html) {
            return html.replace(/<p.*?>/ig, "")
        },
        // change(data) {
        //     this.sections.map((v) => {
        //         v.questions.map((v_) => {
        //             if (v_.id == data.id) {
        //                 v_.myAnswer = data.value;
        //             }
        //         });
        //     });
        //     this.sections = JSON.parse(JSON.stringify(this.sections));
        // },
        change(data) {
            this.answer = data
        },
    },
};
</script>
<style lang="scss" scoped>
.paperHeader {
    background: #FFFFFF;
    padding: 20px;
    border-radius: 5px;

    .paperHeaderTop {
        .paperHeaderTop-title {
            text-align: center;
            font-weight: 500;
            font-size: 22px;
            color: #1A1A1A;
        }

        .paperHeaderTop-c {
            width: 80%;
            margin: auto;
            font-weight: 400;
            font-size: 14px;

            .paperHeaderTop-c-label {
                color: #767676;
            }
        }
    }

}

.paper-con {
    margin-top: 20px;

    .paper-content {
        background: #FFFFFF;
        padding: 20px;
        border-radius: 5px;
        flex:1;
    }

    display: flex;
}

.paperSecTitle {
    font-weight: 500;
    font-size: 14px;
    color: #1A1A1A;
}

.answerBox {
    width: 340px;
    min-width: 340px;
    box-sizing: border-box;
    border-radius: 5px;
    // min-height: 20%;
    // max-height: 80%;
    // height: 100%;
    background: #fff;
    // overflow-y: auto;
    overflow-y: hidden;
    position: sticky;
    top: 10px;
    height: 100%;

    .answerBox-date {
        font-weight: 400;
        font-size: 24px;
        color: #1A1A1A;
        padding: 15px;
        background: #FFF4E8;
    }
}
.page-answer-card-title{
    background-color: #e4e4e4;
    padding:10px;
}
.question-btn{
    text-align:center;
    margin-top:15px;
}
.page-answer-card-content{
    display: flex;
     justify-content: space-between; 
     flex-wrap: wrap;
}

    .card-image:nth-child(4n){ 
          margin-right: 0; 
        } 
        /* 使最后一个元素的边距填满剩余空间 */
        .card-image:last-child{ 
          margin-right: auto; 
        } 
.card-image{
    flex: 0 0 24%; 
          text-align:center;
          background-color: white;
          /* 边距懒得算，css函数代替 */ 
    margin:10px 0;
    margin-right: calc(4% / 3); 
          margin-bottom: calc(4% / 3); 
    position: relative;
    width: 150px;
    height: 150px;
    .delIcon{
        position: absolute;
        top: -8px;
    right: -8px;
    cursor: pointer;
    z-index:2;
    }
}
</style>